import { render, staticRenderFns } from "./LoadingTransparentOverlay.vue?vue&type=template&id=4864f27b&"
import script from "./LoadingTransparentOverlay.vue?vue&type=script&lang=js&"
export * from "./LoadingTransparentOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4864f27b')) {
      api.createRecord('4864f27b', component.options)
    } else {
      api.reload('4864f27b', component.options)
    }
    module.hot.accept("./LoadingTransparentOverlay.vue?vue&type=template&id=4864f27b&", function () {
      api.rerender('4864f27b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlay/LoadingTransparentOverlay.vue"
export default component.exports